<template>
  <div>
    <tabsComponents></tabsComponents>
  </div>
</template>
<script>
import tabsComponents from "../../../common/crumb/components/tabsComponent/tabsComponent";
export default {
  components: {
    tabsComponents
  },

  data() {
    return {};
  },
  mounted() {

  },
  methods: {}
};
</script>
<style lang="less">
</style>